import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/payments
    */
getPayments: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/payments',{
        params:{
            offset:options.offset,
            itemsPerPage:options.itemsPerPage,
            orderBy:options.orderBy,
            orderDirection:options.orderDirection,
            showDeleted:options.showDeleted,
            selectedDay:options.selectedDay,
            selectedType:options.selectedType,
    }});
},

/*
    GET     /api/payments/search
*/
searchPayments: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/payments/search',{
        params:{
            showDeleted:options.showDeleted,
            selectedDay:options.selectedDay,
            selectedType:options.selectedType,
            filterableHeaders:options.filterableHeaders,
            q:options.q
    }});
},
    
    /*
		POST 	/api/payments
	*/
    postAddNewDocument: function( type,child_id, amount,selected,date,orig_document_number,source){
        return axios.post( LOGUS_CONFIG.API_URL + '/payments',
            {
                type: type,
                child_id:child_id,
                amount:amount,
                selected:selected,
                date:date,
                orig_document_number:orig_document_number,
                source:source
            }
        );
    }, 

    /*
		POST 	/api/payments/send
	*/
    postSendDocument: function(child_id, owner_id, document){
        return axios.post( LOGUS_CONFIG.API_URL + '/payments/send',
            {
                child_id:child_id,
                owner_id:owner_id,
                document:document
            },
        );
    }, 

    /*
		GET 	/api/payments/{slug}/edit
	*/
    getDocumentEdit: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/payments/' + slug + '/edit' );
    },

    /*
		PUT 	/api/payments/{slug}
	*/
    putEditDocument: function(slug, type,child_id, amount,selected,date,orig_document_number,source ){
        return axios.put( LOGUS_CONFIG.API_URL + '/payments/'+ slug,
            {
                type: type,
                child_id:child_id,
                amount:amount,
                selected:selected,
                date:date,
                orig_document_number:orig_document_number,
                source:source
            }
        );
    },

    /*
		DELETE /api/payments/{slug}
	*/
    deleteDocument: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/payments/' + slug );
    },

    /*
		GET /api/payments/{slug}/storn
	*/
    getStornDocument: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/payments/' + slug + '/storn');
    },
    
    /*
		GET 	/api/payments/documents
	*/
    getDocumentsForDay: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/payments/documents' );
    },
}